module.exports = __webpack_public_path__ + "img/heart_nebula_sho_one_thumb.06f6e0e2.jpg";